import { handleActions } from "redux-actions";
import { INTEGRATIONS } from "constants/action-types";

export interface IState {
    error?: boolean;
    errorMessage?: any;
    fetching?: boolean;
    schema: any;
    results: string[];
}

const initialState: IState = {
    error: undefined,
    errorMessage: undefined,
    fetching: false,
    schema: undefined,
    results: [],
};

export const masterSchema = handleActions<IState, any>(
    {
        [INTEGRATIONS.MASTER_SCHEMA.FETCH.START]: (state: IState): IState => {
            return { ...state, fetching: true };
        },
        [INTEGRATIONS.MASTER_SCHEMA.FETCH.COMPLETED]: (state: IState, { payload, error }): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    errorMessage: payload,
                    fetching: false,
                    results: state.results,
                };
            }
            return {
                ...state,
                fetching: false,
                results: payload,
            };
        },
    } as any,
    initialState
);
